import { z } from 'zod';

export const MobileButtonsScalarFieldEnumSchema = z.enum(['mobilebuttonId','cityId','icon','label','action','URL','mobileOrder']);

export default MobileButtonsScalarFieldEnumSchema;
